import { cmpntGroup } from "./componentConfig";

export const isValidLicense = (res) => {
    const regex = /<div>(.*?)<\/div>/;
    const match = res.match(regex);
    return match;
}


export const validationForRoles = (groups) => {
    // console.log("groups>>>>", groups);
    let groupsValid = {};
    Object.keys(groups).forEach((key) => {
        let splitValues = groups[key].split("");
        groupsValid[key] = {
            "Add": splitValues[0] === "Y",
            "Read": splitValues[1] === "Y",
            "Update": splitValues[2] === "Y",
            "Delete": splitValues[3] === "Y"
        };
    });

    // console.log("groupsValid>>>>" , groupsValid);

    Object.keys(groups).map((n) => (
        cmpntGroup[n] = true
    )) 

    sessionStorage.setItem("cmpntGroup", JSON.stringify(groupsValid));
    return groupsValid;
}

export const validationExitRoles = () => {
    const cmpntGroup = JSON.parse(sessionStorage.getItem("cmpntGroup")) instanceof Object ? JSON.parse(sessionStorage.getItem("cmpntGroup")) : {};
    
    let groupsValid = {};
    Object.keys(cmpntGroup).forEach((key) => {
        groupsValid[key] = {
            "Add": false,
            "Read": false,
            "Update": false,
            "Delete": false
        };
    });

    Object.keys(cmpntGroup).map((n) => (
        cmpntGroup[n] = false
    ))

    sessionStorage.setItem("cmpntGroup", JSON.stringify(cmpntGroup));
}